import gql from 'graphql-tag'

export const GET_REFERRAL_BONUS_POLICY_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getReferralBonusPolicyPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        id
				level {
					level
					title
				}
				bonus
				refBonus
      }
    }
  }
`;

export const GET_REFERRAL_BONUS_POLICY_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getReferralBonusPolicy (
      data: {
        id: $id
      }
    ) {
      id
			level {
				level
				title
			}
			bonus
			refBonus
    }
  }
`;
